module.exports = __webpack_public_path__ + "img/cajaChicasSantiagoOF.06cdad67.svg";